module.exports = {
  // getter定数
  GET_USERS: 'GET_USERS',
  GET_OBJECTIVES: 'GET_OBJECTIVES',
  GET_KEYRESULTS: 'GET_KEYRESULTS',
  GET_1ON1S: 'GET_1ON1S',
  GET_1ON1S_DATE: 'GET_1ON1S_DATE',
  GET_1ON1S_REQUESTS: 'GET_1ON1S_REQUESTS',
  GET_RTFBS: 'GET_RTFBS',
  GET_COMMENTS: 'GET_COMMENTS',
  GET_GROUPS: 'GET_GROUPS',
  GET_NOTICESSETTINGS: 'GET_NOTICESETTINGS',
  GET_CURRENT_NOTICESETTINGS: 'GET_CURRENT_NOTICESETTINGS',
  GET_DRAFTS_OBJECTIVES: 'GET_DRAFTS_OBJECTIVES',
  GET_DRAFTS_KEYRESULTS: 'GET_DRAFTS_KEYRESULTS',
  GET_DRAFTS_1ON1S: 'GET_DRAFTS_1ON1S',
  GET_DRAFTS_RTFBS: 'GET_DRAFTS_RTFBS',
  GET_LATEST_ACCESS: 'GET_LATEST_ACCESS',
  // unbind定数
  UNBIND_LATEST_ACCESS: 'UNBIND_LATEST_ACCESS',
  // // currentGetter定数
  GET_USER_INFO: 'GET_USER_INFO',
  GET_CURRENT_OBJECTIVES: 'GET_CURRENT_OBJECTIVES',
  GET_CURRENT_KEYRESULTS: 'GET_CURRENT_KEYRESULTS',
  GET_CURRENT_1ON1S: 'GET_CURRENT_1ON1S',
  GET_CURRENT_1ON1S_DATE: 'GET_CURRENT_1ON1S_DATE',
  GET_CURRENT_1ON1S_REQUESTS: 'GET_CURRENT_1ON1S_REQUESTS',
  // GET_CURRENT_RTFBS: 'GET_CURRENT_RTFBS',
  GET_CURRENT_COMMENTS: 'GET_CURRENT_COMMENTS',
  GET_CURRENT_GROUPS: 'GET_CURRENT_GROUPS',
  GET_CURRENT_NOTICES: 'GET_CURRENT_NOTICES',
  GET_CURRENT_DRAFTS_OBJECTIVES: 'GET_CURRENT_DRAFTS_OBJECTIVES',
  GET_CURRENT_DRAFTS_KEYRESULTS: 'GET_CURRENT_DRAFTS_KEYRESULTS',
  GET_CURRENT_DRAFTS_1ON1S: 'GET_CURRENT_DRAFTS_1ON1S',
  GET_CURRENT_DRAFTS_RTFBS: 'GET_CURRENT_DRAFTS_RTFBS',
  // GET_FB_USER_ICONS: 'GET_FB_USER_ICONS',
  // metaData
  GET_USER_NAME_KEY: 'GET_USER_NAME_KEY',
  GET_GROUP_NAME_KEY: 'GET_GROUP_NAME_KEY',
  GET_ORGANIZATION_NAME_KEY: 'GET_ORGANIZATION_NAME_KEY',

  GET_META_USERS_LIST: 'GET_META_USERS_LIST',
  GET_META_EMAILS_LIST: 'GET_META_EMAILS_LIST',
  GET_META_USER_EMAILS_LIST: 'GET_META_USER_EMAILS_LIST',
  GET_META_PROGRESS: 'GET_META_PROGRESS',
  UNBIND_META_PROGRESS: 'UNBIND_META_PROGRESS',
  GET_META_SUMMARY: 'GET_META_SUMMARY',
  UNBIND_META_SUMMARY: 'UNBIND_META_SUMMARY',
  GET_META_VERSION_CHECK: 'GET_META_VERSION_CHECK',

  // setter関数用定数
  SET_GROUP_INACTIVE: 'SET_GROUP_INACTIVE',
  SET_CURRENT_NOTICESETTNGES: 'SET_CURRENT_NOTICESETTNGES',
  SET_CURRENT_TIMESTAMP: 'SET_CURRENT_TIMESTAMP',
  SET_DEFAULT_USER_INFO: 'SET_DEFAULT_USER_INFO',
  SET_NEW_PROFILE: 'SET_NEW_PROFILE',
  SET_PROFILE: 'SET_PROFILE',
  SET_FEELING: 'SET_FEELING',
  SET_NEW_OBJECTIVE: 'SET_NEW_OBJECTIVE',
  SET_DRAFTS_OBJECTIVES: 'SET_DRAFTS_OBJECTIVES',
  SET_DRAFTS_KEYRESULTS: 'SET_DRAFTS_KEYRESULTS',
  REMOVE_DRAFTS_OBJECTIVES: 'REMOVE_DRAFTS_OBJECTIVES',
  REMOVE_DRAFTS_KEYRESULTS: 'REMOVE_DRAFTS_KEYRESULTS',
  SET_NEW_ONE: 'SET_NEW_ONE',
  SET_NEW_ONEDATE: 'SET_NEW_ONEDATE',
  SET_ONES_LIKES: 'SET_ONES_LIKES',
  REMOVE_ONES_LIKES: 'REMOVE_ONES_LIKES',
  SET_NEW_FBREQUEST: 'SET_NEW_FBREQUEST',
  SET_NEW_SEND_1ON1S: 'SET_NEW_SEND_1ON1S',
  SET_NEW_GET_1ON1S: 'SET_NEW_GET_1ON1S',
  REMOVE_SEND_1ON1S: 'REMOVE_SEND_1ON1S',
  REMOVE_GET_1ON1S: 'REMOVE_GET_1ON1S',
  SEND_NEW_COMMENT: 'SEND_NEW_COMMENT',
  SET_NEW_COMMENT: 'SET_NEW_COMMENT',
  REMOVE_ITEM: 'REMOVE_ITEM',
  REMOVE_GROUP: 'REMOVE_GROUP',
  REMOVE_CURRENTGROUP: 'REMOVE_CURRENTGROUP',
  REMOVE_COMMENT: 'REMOVE_COMMENT',
  SET_NEW_KEYRESULT: 'SET_NEW_KEYRESULT',
  REMOVE_OBJECTIVE: 'REMOVE_OBJECTIVE',
  SET_OBJECTIVE_COMPLETENESS: 'SET_OBJECTIVE_COMPLETENESS',
  SET_DRAFTS_RTFBS: 'SET_DRAFTS_RTFBS',
  REMOVE_DRAFTS_RTFBS: 'REMOVE_DRAFTS_RTFBS',
  SET_DRAFTS_1ON1S: 'SET_DRAFTS_1ON1S',
  REMOVE_DRAFTS_1ON1S: 'REMOVE_DRAFTS_1ON1S',
  SET_ITEM_COMPLETENESS: 'SET_ITEM_COMPLETENESS',
  REMOVE_ITEM_ISCOMPLETE: 'REMOVE_ITEM_ISCOMPLETE',
  REMOVE_TERMS_FLAG: 'REMOVE_TERMS_FLAG',
  REMOVE_TUTORIAL_FLAG: 'REMOVE_TUTORIAL_FLAG',
  SET_READ_TIME: 'SET_READ_TIME',
  GET_READ_TIMES: 'GET_READ_TIMES',
  // SET_DRAFTS_RTFBS: 'SET_DRAFTS_RTFBS',
  // SET_NEW_KEYRESULT: 'SET_NEW_KEYRESULT',
  SET_LIKES: 'SET_LIKES',
  REMOVE_LIKES: 'REMOVE_LIKES',
  SET_LAST_NOTICE: 'SET_LAST_NOTICE',
  SET_1ON1REQ_LAST_NOTICE: 'SET_1ON1REQ_LAST_NOTICE',
  SET_FOLLOWING_USERS: 'SET_FOLLOWING_USERS',
  SET_FOLLOWING_GROUPS: 'SET_FOLLOWING_GROUPS',
  SET_FOLLOWING_ORGANIZATIONS: 'SET_FOLLOWING_ORGANIZATIONS',
  REMOVE_FOLLOWING: 'REMOVE_FOLLOWING',
  SET_ITEM_PROGRESS: 'SET_ITEM_PROGRESS',
  SET_NEW_GROUP: 'SET_NEW_GROUP',
  SET_VISIT_HISTORY: 'SET_VISIT_HISTORY',
  REMOVE_ONEDATE: 'REMOVE_ONEDATE',
  ADD_RELATION: 'ADD_RELATION',
  REMOVE_RELATION: 'REMOVE_RELATION',
  REMOVE_USER: 'REMOVE_USER',
  SET_OKR_ORDER_TYPE: 'SET_OKR_ORDER_TYPE'
}



// WEBPACK FOOTER //
// ./src/stores/getterConstants.js